import React from 'react';
import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import { GroceriesStepNumber } from 'src/components/enterprise/features/Groceries/components/GroceriesHowItWorks/GroceriesStepNumber';
import { GroceriesHowItWorksStepData } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

export interface GroceriesHowItWorksStepProps {
  step: GroceriesHowItWorksStepData;
}

export function GroceriesHowItWorksStep({
  step: { number, title, description },
}: GroceriesHowItWorksStepProps): JSX.Element {
  return (
    <Flex alignItems="center">
      <Stack x="lg" flexShrink={0}>
        <GroceriesStepNumber number={number} />
      </Stack>
      <Stack>
        <Stack y="xxx-sm">
          <Heading variant="h4">{title}</Heading>
        </Stack>
        <Copy variant="body">{description}</Copy>
      </Stack>
    </Flex>
  );
}
